define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/agentItemView.tmpl");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var InputField = require("ui/input-field/InputField");
    var InlineInput = require("ui/inline-input/InlineInput");
    var Checkbox = require("ui/checkbox/Checkbox");
    var ValidationUtilities = require("utils/ValidationUtilities");
    var Button = require("ui/button/Button");

    var AgentItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        AgentItemView = Marionette.ItemView.extend({

            template:template,
            tagName:'li',
            className:'agent-item',

            ui: {
                "displayNamePropertyValue": ".display-name-value",
                "displayNameReset": ".display-name-reset-container",
                "displayNameEnable": "display-name-enable"
            },

            uiComponents: {
                propertyValue: {
                    type:InlineInput,
                    options:{
                        permutation:InlineInput.PERMUTATION.B,
                        container:"view.ui.displayNamePropertyValue",
                        value: "view.getPropertyValue",
                        allowNull: "view.isEditable"
                    },
                    events:{
                        onblur: "onDisplayNamePropertyValueChange",
                        change: "onDisplayNamePropertyValueChange"
                    }
                },
                resetButton : {
                    type : Button,
                    options : {
                        permutation:Button.PERMUTATION.BLUELINK,
                        el : "view.ui.displayNameReset",
                        initState : Button.STATES.ENABLED
                    },
                    events : {
                        click : "resetDisplayNameValues"
                    }
                },
                enableProperty: {
                    type: Checkbox,
                    options:{
                        el: "view.ui.displayNameEnable",
                        permutation: Checkbox.PERMUTATION.B,
                        label: "",
                        checked: false
                    },
                    events: {
                        change: "onRowSelect"
                    }
                }
            },

            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                var split;
                var name;

                LEManager.logger.debug("AgentItemView:initialize");
                this.vent = LEManager.media.channel("dataSources").vent;

                name = this.model && this.model.get("SDEPath");
                split = name && name.split(".") || "";
                name = split[split.length - 1];

                this.uiComponents.propertyValue.options.placeholder = name;
            },

            customTemplateHelpers: function() {
                var that = this;
                return {
                    propertyName: function(){
                        return that.model.getName();
                    },
                    propertyLogicalName: function() {
                        return that.model.getLogicalName();
                    },
                    isEditable: function(){
                        return that.isEditable();
                    }
                };
            },

            onRender: function(){
                LEManager.logger.debug("AgentItemView:onRender");
                this.setPropertyValuePlaceholder();
            },

            onInvalid:function (model, errors) {
                LEManager.logger.info("AgentItemView:onInvalid");
                ValidationUtilities.setValidationErrors(this);
            },

            clearErrors: function(){
                LEManager.logger.debug("AgentItemView:clearErrors");
                this.uiComponents.propertyValue.setError(false);
            },

            getPropertyValue: function(){
                LEManager.logger.debug("AgentItemView:getPropertyValue");
                return this.model.getAgentDisplayNameValue();
            },

            isEditable: function() {
                LEManager.logger.debug("AgentItemView:isEditable");
                return this.model.isAgentEditable();
            },

            resetDisplayNameValues: function(){
                LEManager.logger.debug("AgentItemView:resetDisplayNameValues");
                this.uiComponents.propertyValue.setValue(null);
                this.uiComponents.propertyValue.setError(false);
                this.setDisplayNameValue(null);
                this.setPropertyValuePlaceholder();
            },

            setPropertyValuePlaceholder: function(){
                LEManager.logger.debug("AgentItemView:setPropertyValuePlaceholder");
            },

            setDisplayNameValue: function(value){
                LEManager.logger.debug("AgentItemView:setDisplayNameValue - value: " + value);
                if (this.model.getAgentDisplayNameValue() !== value){
                    //var val = value === "" ? undefined : value;
                    this.model.setAgentDisplayNameValue(value);
                    this.vent.trigger(ManagerConfig.dataSources.mainConfig.agent.TRIGGERING.PROPERTIES_CHANGED, this.model);
                }
            },

            onRowSelect:function (componentId, eventName, isChecked) {
                this.trigger("itemClicked", isChecked);
            },

            onDisplayNamePropertyValueChange: function(componentId, eventName, value){
                LEManager.logger.debug("AgentItemView:onDisplayNamePropertyValueChange");
                this.setDisplayNameValue(value);
            },

            onClose: function() {
                LEManager.logger.debug("AgentItemView:onClose");
            }

        });
    });

    return AgentItemView;
});
